export default __webpack_public_path__ + "static/Email-12f730cbd4fe5fadc041a6f05c5c4c22.png";